import React from 'react'
import { de, enGB } from 'date-fns/locale'
import moment from 'moment'
import ReactDatePicker from 'react-datepicker'

import 'react-datepicker/dist/react-datepicker.css'

type DatePickerProps = {
  initialDate: moment.Moment
  onChange: (date: moment.Moment) => void
  valid: boolean
  errorMessage: string
  maxDate?: moment.Moment | null
}

export default function DatePicker({
  initialDate,
  onChange,
  valid,
  errorMessage,
  maxDate = null,
}: DatePickerProps) {
  moment.locale(window.jsProps.lang)
  const pickerLocale = window.jsProps.lang === 'de' ? de : enGB
  const maxDateValue = maxDate?.toDate()

  return (
    <div className="DatePicker">
      <div className="DatePicker__Calendar">
        <ReactDatePicker
          inline
          selected={initialDate.toDate()}
          onChange={(value: Date | null) => {
            if (!value) {
              return
            }
            onChange(moment(value))
          }}
          minDate={new Date()}
          maxDate={maxDateValue}
          dateFormat="dd.MM.yyyy"
          locale={pickerLocale}
          calendarClassName="DatePicker__CalendarInner"
        />
      </div>
      {!valid && <div className="DatePicker__Error">{errorMessage}</div>}
    </div>
  )
}
